import { ChevronLeft } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import useObservable from '../../../../../Shared/Hooks/useObservable.Hook';
import { st, classes } from './SearchResultsText.st.css';
import { resetSearch } from '../../../../Services/Search.service';
import { getSelectedFolder } from '../../../../Services/SelectedFolder.service';
import { getAppSettings } from '../../../../Services/AppSettings.service';
import { useAppContext } from '../../../../Shared/AppContext';

const SearchResultsText = () => {
  const { t } = useTranslation();
  const { compId } = useAppContext();
  const [, selectedFolder]: any = useObservable(getSelectedFolder(compId));
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = getAppSettings !== undefined ? AppSettings?.isMobile : '';
  const resultsText =
    selectedFolder && selectedFolder.libraryItems
      ? t('app.widget.search.results.title', {
          resultsNum: selectedFolder.libraryItems.length,
        })
      : '';

  const handleOnClick = () => {
    resetSearch(compId);
  };

  return (
    <div className={classes.searchResultsContainer}>
      <ChevronLeft className={classes.backIcon} onClick={handleOnClick} />
      <Text className={st(classes.resultsText, { isMobile })}>
        {resultsText}
      </Text>
    </div>
  );
};

export default SearchResultsText;
